<div class="property-summary-page">
    <tg-row>
        <tg-col>
            <h1>Your listing summary</h1>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col>
            <p>You’re almost ready to go! Here’s a summary of your listing.</p>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-property-information-section></property-summary-page-property-information-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <new-homes-property-summary-page-sale-details-section></new-homes-property-summary-page-sale-details-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-open-homes-section></property-summary-page-open-homes-section>
            </div>
        </tg-col>
    </tg-row>
    <property-summary-page-agent-contact-details-section></property-summary-page-agent-contact-details-section>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-agent-property-description-section></property-summary-page-agent-property-description-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-photos-media-section></property-summary-page-photos-media-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-agent-promotions-section></property-summary-page-agent-promotions-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--last
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-agent-summary-section></property-summary-page-agent-summary-section>
            </div>
        </tg-col>
    </tg-row>
</div>
<property-summary-page-validation-summary-section></property-summary-page-validation-summary-section>
